<!-- SPDX-License-Identifier: AGPL-3.0-only -->

<script setup lang="ts">
import AppFooter from "../components/AppFooter.vue";
import ProductMark from "../components/ProductMark.vue";
</script>

<template>
  <div class="legal-page">
    <header class="legal-page__header">
      <RouterLink :to="{ name: 'home' }" aria-label="Return to LacunaScope">
        <ProductMark />
      </RouterLink>
    </header>
    <main class="legal-content">
      <p class="eyebrow">Legal information</p>
      <h1>Privacy policy</h1>
      <p class="legal-content__lead">
        LacunaScope is self-hosted software. The operator of this installation is responsible for
        the personal data processed by this deployment and for providing its legally required
        contact and privacy information.
      </p>

      <section>
        <h2>Data processed by LacunaScope</h2>
        <p>
          Depending on configuration and use, the system stores account information, tenant
          memberships, authentication sessions, audit events, probe configuration, connectivity
          measurements, and delivery metadata for system email.
        </p>
      </section>
      <section>
        <h2>Authentication and cookies</h2>
        <p>
          Local authentication uses a necessary session cookie to keep users signed in. LacunaScope
          does not require advertising or cross-site tracking cookies.
        </p>
      </section>
      <section>
        <h2>Recipients and retention</h2>
        <p>
          Data recipients, SMTP providers, external identity providers, retention periods, legal
          bases, and data-subject contact details depend on the operator's deployment. The operator
          must document these details before making the installation available to other people.
        </p>
      </section>
      <div class="notice notice--warning">
        This product information is not a complete operator-specific legal declaration. Deployment
        documentation must be supplemented with the responsible operator's details.
      </div>
    </main>
    <AppFooter />
  </div>
</template>
